const GENERIC_OR_LOCAL = new Set([
  'serif',
  'sans-serif',
  'monospace',
  'cursive',
  'fantasy',
  'system-ui',
  'ui-sans-serif',
  'ui-serif',
  'ui-monospace',
  'axiforma',
  'helvetica',
  'arial',
])

const LINK_ID = 'sp-studio-fonts'

/** First family name from a CSS stack (`"DM Sans", sans-serif` → `DM Sans`). */
export function firstFontFamily(stack: string): string {
  const first = stack.split(',')[0]?.trim() ?? ''
  return first.replace(/^["']|["']$/g, '').trim()
}

export function shouldLoadWebfont(stack: string): boolean {
  const name = firstFontFamily(stack)
  if (!name || /^https?:/i.test(name)) return false
  return !GENERIC_OR_LOCAL.has(name.toLowerCase())
}

export function googleFontsCss2Url(stacks: string[]): string | null {
  const names: string[] = []
  stacks.filter(shouldLoadWebfont).forEach((stack) => {
    const name = firstFontFamily(stack)
    if (names.indexOf(name) === -1) names.push(name)
  })
  if (!names.length) return null
  const families = names
    .map((name) => `family=${encodeURIComponent(name).replace(/%20/g, '+')}:wght@400;600;700`)
    .join('&')
  return `https://fonts.googleapis.com/css2?${families}&display=swap`
}

export function injectStudioFontLinks(stacks: string[]): void {
  if (typeof document === 'undefined') return
  const href = googleFontsCss2Url(stacks)
  const existing = document.getElementById(LINK_ID)
  if (!href) {
    existing?.remove()
    return
  }
  if (existing instanceof HTMLLinkElement) {
    existing.href = href
    return
  }
  const link = document.createElement('link')
  link.id = LINK_ID
  link.rel = 'stylesheet'
  link.href = href
  document.head.appendChild(link)
}

export function removeStudioFontLinks(): void {
  if (typeof document === 'undefined') return
  document.getElementById(LINK_ID)?.remove()
}
